<template src="./html/UsersMap.html"></template>

<script>
export default {
	props: ['user', 'isAuth', 'users', 'profile'],
	data () {
		return {
			modal: {
				selector: 'users-map'
			},
			map: {
				center: {
					lat: 0,
					lng: 0,
				},
				zoom: 10,
				markers: null,
			},
			infoContent: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMidx: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -25
				}
			},
		}
	},
	watch: {
		'map.zoom'() {
			this.reZoom(this.map.zoom)
		},
	},
	mounted() {
		if(this.$platform.place) {
			this.map.center.lat = parseFloat(this.$platform.place.lat)
			this.map.center.lng = parseFloat(this.$platform.place.lng)
		}
		var that = this
		$('#' + this.modal.selector).on('shown.bs.modal', function () {
			that.loadMarker()
		})
	},
	methods: {
		open() {
			$('#' + this.modal.selector).modal('show');
		},
		close() {
			$('#' + this.modal.selector).modal('toggle');
		},
		loadMarker() {
			if(this.users) {
				var map = this.$refs.gmapMap.$mapObject
				var that = this
				var markers = []
				this.users.forEach(function(element, key) {
					if(element.profile.place) {
						if(element.profile.place.lat && element.profile.place.lng) {
							var marker = {
								id: key,
								position: {
									lat: parseFloat(element.profile.place.lat),
									lng: parseFloat(element.profile.place.lng),
								},
								infoText: element,
							}

							that.setMarker(marker)
							markers.push(marker)
						}
					}
				})
				this.$set(this.map, 'markers', markers)
				this.fitBounds()
			} else if(this.profile) {
				var markers = []

				var avatar =  null
				if(this.profile.profile) {
					if(this.profile.profile.avatar) {
						avatar = this.profile.profile.avatar
					}
				}

				var marker = {
					id: this.profile.id,
					position: {
						lat: parseFloat(this.profile.profile.place.lat),
						lng: parseFloat(this.profile.profile.place.lng),
					},
					infoText: this.profile,
				}

				this.setMarker(marker)
				
				markers.push(marker)

				this.$set(this.map, 'markers', markers)
				this.fitBounds()
			}
		},
		toggleInfoWindow (marker, idx) {
			this.infoWindowPos = marker.position;
			this.infoContent = marker.infoText;
			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		},
		fitBounds() {
			var b = new google.maps.LatLngBounds()
			this.map.markers.forEach(function(element) {
				b.extend({
					lat: element.position.lat,
					lng: element.position.lng,
				});
			})
			this.$refs.gmapMap.fitBounds(b)
			if(this.map.markers.length == 1) {
				this.map.zoom = 12
			}
		},
		setMarker(marker) {
			var Marker = this.marker()
			var map = this.$refs.gmapMap.$mapObject
			var myLatlng = new google.maps.LatLng(marker.position.lat, marker.position.lng)
			var overlay = new Marker(
				myLatlng,
				map,
				{
					marker: marker,
				}
			)
		},
		marker(marker) {
			var CustomMarker = function(latlng, map, args) {
				this.latlng = latlng
				this.args = args
				this.setMap(map)
			}

			CustomMarker.prototype = new google.maps.OverlayView();

			var that = this

			CustomMarker.prototype.draw = function() {
				var self = this;
				
				var div = this.div;

				if(!div) {
					div = this.div = document.createElement('div');
					
					div.id = 'marker';
					div.style.width = '50px';
					div.style.height = '50px';
					if(self.args.marker.infoText.profile.available == 1) {
						div.className = 'marker-available';
					} else {
						div.className = 'marker-unavailable';
					}
					
					div.dataset.marker_id = self.args.marker.id;

					var img = document.createElement('img');
					if(self.args.marker.infoText.profile.avatar) {
						img.src = self.args.marker.infoText.profile.avatar;
						if(self.args.marker.infoText.profile.available == 1) {
							img.className = 'marker-avatar profile-available img-responsive';
						} else {
							img.className = 'marker-avatar profile-unavailable img-responsive';
						}
						div.appendChild(img)
					} else {
						img.src = that.$env.ROOT + '/img/no-profile-pic.jpg';
						if(self.args.marker.infoText.profile.available == 1) {
							img.className = 'marker-avatar profile-available img-responsive';
						} else {
							img.className = 'marker-avatar profile-unavailable img-responsive';
						}
						div.appendChild(img)
					}
					var panes = this.getPanes();
					panes.overlayImage.appendChild(div);
				}
				
				var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
				
				if (point) {
					div.style.left = (point.x - 25) + 'px';
					div.style.top = (point.y - 50) + 'px';
				}
			}
			return CustomMarker
		},
		dateUnavailable (unavailable) {
			if(unavailable.length) {
				for (var i = 0; i < unavailable.length; i++) {
					var element = unavailable[i]
					var start = moment(element.start_date)
					var end = moment(element.end_date)
					if(moment().isBetween(start, end)) {
						return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
					}
				}
			}
		},
		reZoom() {
			this.$refs.gmapMap.$mapObject.setZoom(this.map.zoom)
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/users/views/UsersMap.vue